import React, {Component} from 'react';
import {connect} from "react-redux";
import PropTypes from "prop-types";
import Question from "../Question/index";
import _ from "lodash";
import PageTimerMin from "./components/PageTimerMin";
import PageTimerMax from "./components/PageTimerMax";

class Page extends Component {
  constructor(props) {
    super(props);

    this.handleQuestionResponseUpdate = this.handleQuestionResponseUpdate.bind(this);
    props.page.questions.forEach((item) => {
      this['question' + item.id] = React.createRef();
    })
  }

  handleQuestionResponseUpdate(){
    this.props.handleQuestionResponse();
  }

  validate(){
    const {pageRedux, page} = this.props;

    let validate = {
      valid: true,
      errors: [],
      questions: []
    };

    if(!pageRedux.minTimeValidate){
      validate.valid = false;
    }

    page.questions.forEach((item) => {
      const question = this['question' + item.id];

      if (question && question.current) {
        if (!question.current.validate().valid) {
          validate.valid = false;
          validate.questions.push(item.id)
        }
      }
    });

    return validate;
  }

  componentDidMount() {
    const url = new URL(window.location.href);
    url.searchParams.forEach((value, key) => {
      if(key === 'validate' && value){
        setTimeout(() => {
          this.validate()
        })
      }
    })
  }

  componentWillReceiveProps(nextProps, nextContext) {
    nextProps.page.questions.forEach((item) => {
      this['question' + item.id] = React.createRef();
    })
  }

  render() {
    const {page, intl} = this.props;

    return (
      <React.Fragment>
        {(page && page.timeMin > 0) && <PageTimerMin page={page} time={page.timeMin} />}
        {(page && page.timeMax > 0) && <PageTimerMax page={page} changePage={this.props.changePage} time={page.timeMax} />}

        {(page && page.questions) && page.questions.map(question => {
          return <Question
            key={'q'+question.id}
            intl={intl}
            ref={this['question' + question.id]}
            onQuestionResponseUpdate={this.handleQuestionResponseUpdate}
            question={question}
            changePage={this.props.changePage}
            isLastOnPage={_.isUndefined(page.questions[page.questions.indexOf(question) + 1])}
          />
        })}
      </React.Fragment>
    )
  }
}

Page.propTypes = {
  handleQuestionResponse: PropTypes.func.isRequired,
  changePage: PropTypes.func.isRequired,
  page: PropTypes.shape({
    questions: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.number.isRequired,
      content: PropTypes.string,
      excludings: PropTypes.array.isRequired,
    }).isRequired).isRequired,
    timeMin: PropTypes.number.isRequired,
    timeMax: PropTypes.number.isRequired,
  }).isRequired,
  intl: PropTypes.object.isRequired,
};

function mapStateToProps(state) {
  return {
    pageRedux: state.page,
  }
}

export default connect(mapStateToProps, null, null, {withRef: true, forwardRef: true})(Page);